import apiClient from './authService';

export const chatService = {
  getChatHistory: async (sessionId) => {
    const response = await apiClient.get(`/api/chat/${sessionId}`);
    return response.data;
  },

  sendMessage: async (sessionId, message, userId, imageUrls = null) => {
    const body = { message, userId };
    if (imageUrls && imageUrls.length > 0) {
      body.image_urls = imageUrls;
    }
    const response = await apiClient.post(`/api/chat/${sessionId}/message`, body);
    return response.data;
  },

  getChatSessions: async () => {
    const response = await apiClient.get('/api/chat/sessions/list');
    return response.data;
  }
};